export default __webpack_public_path__ + "static/media/placeholder_dummy2016-nagelstudio01-mobile-de.a5ab2374.png";